export default __webpack_public_path__ + "static/media/inframail-16x16.77e889db.svg";